// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acronyms {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sebrae-white);
  font-family: var(--font-lato);
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/acronyms/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,6CAAA;EACA,eAAA;AADF","sourcesContent":[".acronyms {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--sebrae-white);\n  font: {\n    family: var(--font-lato);\n    size: 16px;\n    weight: 700;\n  }\n  text-transform: uppercase;\n  box-shadow: 0 1px 4px 0 #142e5233;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
